import { ClickAwayListener } from '@mui/base'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton } from '@mui/material'
import { ActionsPopper } from 'Components/_common/ContentPreview/ActionsPopper/ActionsPopper'
import React, { useState } from 'react'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

import { useSuperAdmin } from '../../../hooks/useSuperAdmin'
import { navigateToContestPaymentsPage } from '../../../Scenes/navigators'

const ContestActions = ({ contentId, goToEditPage, type }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const isSuperAdmin = useSuperAdmin()

  if (!contentId) return null

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const popperActions = [
    {
      onClick: () => goToEditPage(contentId),
      showItem: true,
      isCopyCovered: false,
      icon: FA_ICONS.GEAR,
      title: `Edit ${type}`,
      color: 'text.tertiary',
    },
    isSuperAdmin && {
      onClick: () => navigateToContestPaymentsPage(contentId),
      showItem: true,
      isCopyCovered: false,
      icon: FA_ICONS.DOLLAR_SIGN,
      title: 'Payments',
      color: 'text.tertiary',
    },
  ]

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <IconButton
          aria-label="more"
          aria-controls="menu"
          aria-haspopup="true"
          onClick={handleClick}
          size="large"
        >
          <MoreVertIcon />
        </IconButton>
        <ActionsPopper
          anchorEl={anchorEl}
          actions={popperActions}
          open={!!anchorEl}
        />
      </div>
    </ClickAwayListener>
  )
}

export default ContestActions
